import { fork, all } from 'redux-saga/effects';
import authFlow from './authFlow';
import userFlow from './userFlow';
import assessmentFlow from './assessmentFlow';
import sectionFlow from './sectionFlow';
import institutionFlow from './institutionFlow';
import bugReportFlow from './bugReportFlow';

export default function* root() {
  yield all([
    fork(authFlow),
    fork(assessmentFlow),
    fork(userFlow),
    fork(sectionFlow),
    fork(institutionFlow),
    fork(bugReportFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js